// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f93e8dec","297":"2dd05fd7","756":"e3757fb4","823":"1866e4ce"}[chunkId] + ".chunk.js";
};